var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reset-password-component" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading-state" }, [
          _c("p", [_vm._v("Loading password requirements...")]),
        ])
      : _vm.success
      ? _c("div", { staticClass: "success-message" }, [
          _c("h3", [_vm._v("Password Updated Successfully!")]),
          _vm._v(" "),
          _vm.isExpired
            ? _c("p", [
                _vm._v(
                  "\n      Your expired password has been reset successfully. You can now login\n      with your new password.\n    "
                ),
              ])
            : _c("p", [_vm._v("Your password has been reset successfully.")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-secondary",
              on: { click: _vm.redirectToLogin },
            },
            [
              !_vm.isExpired
                ? _c("span", { staticClass: "osci osci-chevron-left" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isExpired
                ? _c("span", [_vm._v("Continue to dashboard")])
                : _c("span", [_vm._v("Back to login")]),
              _vm._v(" "),
              _vm.isExpired
                ? _c("span", { staticClass: "osci osci-chevron-right" })
                : _vm._e(),
            ]
          ),
        ])
      : _c(
          "div",
          { staticClass: "password-form" },
          [
            _c("div", { staticClass: "password-form-header" }, [
              _vm.isExpired
                ? _c("h3", [_vm._v("Your password has expired")])
                : _c("h3", [_vm._v("Reset your password")]),
              _vm._v(" "),
              _vm.isExpired
                ? _c("p", [
                    _c("span", {
                      staticClass: "osci osci-notification-circle",
                      staticStyle: { color: "#f39c12" },
                    }),
                    _vm._v(
                      " \n        Your password has expired and must be reset to continue.\n      "
                    ),
                  ])
                : _c("p", [
                    _c("span", {
                      staticClass: "osci osci-notification-circle",
                    }),
                    _vm._v(
                      " \n        Please enter your new password below.\n      "
                    ),
                  ]),
            ]),
            _vm._v(" "),
            _c("password-strength", {
              attrs: { password: _vm.password, policy: _vm.passwordPolicy },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("password-input", {
                  attrs: {
                    id: "password",
                    placeholder: "Enter your new password",
                    disabled: _vm.submitting,
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("password-input", {
                  attrs: {
                    id: "confirmPassword",
                    placeholder: "Confirm your new password",
                    disabled: _vm.submitting,
                  },
                  model: {
                    value: _vm.confirmPassword,
                    callback: function ($$v) {
                      _vm.confirmPassword = $$v
                    },
                    expression: "confirmPassword",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("password-requirements", {
              attrs: {
                password: _vm.password,
                "confirm-password": _vm.confirmPassword,
                policy: _vm.passwordPolicy,
                errors: _vm.errors,
                "strength-level":
                  _vm.passwordPolicy && _vm.passwordPolicy.allowWeakPasswords
                    ? 4
                    : _vm.strengthLevel,
                requirements: _vm.getPasswordRequirements(),
              },
            }),
            _vm._v(" "),
            _c("submit-button", {
              attrs: {
                disabled: !_vm.isFormValid || _vm.submitting,
                loading: _vm.submitting,
                text: "Reset Password",
              },
              on: { click: _vm.submitPasswordReset },
            }),
            _vm._v(" "),
            _vm._m(0),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-actions" }, [
      _c(
        "a",
        { staticClass: "btn-secondary", attrs: { href: "/Account/Login" } },
        [
          _c("span", { staticClass: "osci osci-chevron-left" }),
          _vm._v(" Back to login\n      "),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }